// Class strings copied from the pages this one sits beside (Competitive, Event and
// Weather Intelligence, Search Console, AIM) so Local Intelligence reads as the same
// product. Kept in one place so every component on the page uses the same values.

// The house card — CI, EI and Weather panels.
export const CARD = 'bg-white dark:bg-gray-900 rounded-xl shadow border border-gray-200 dark:border-gray-800';
export const CARD_PAD = `${CARD} p-5`;
export const CARD_LIST = `${CARD} overflow-hidden`;

// Card heading (CI/EI `h2`) and the small uppercase label (CI `h3`).
export const CARD_TITLE = 'text-base font-semibold text-gray-900 dark:text-gray-100 inline-flex items-center gap-1.5';
export const EYEBROW = 'text-[11px] uppercase tracking-wide font-semibold text-gray-500 dark:text-gray-400';

// Filter pill — CI's category row; brand-blue tint when active.
export const chipClass = (active) =>
  `px-3 py-1 text-sm rounded-full border transition-colors ${
    active
      ? 'border-[#32B1FF] bg-[#32B1FF]/10 text-[#32B1FF]'
      : 'border-gray-300 dark:border-gray-700 text-gray-600 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-800'
  }`;

// Buttons: primary is the brand-blue fill the dashboard uses for its main action;
// secondary is the bordered neutral button.
export const BTN_PRIMARY =
  'inline-flex items-center justify-center gap-1.5 px-3 py-1.5 text-sm font-medium rounded-lg bg-[#32B1FF] text-white hover:bg-[#259ae6] transition-colors disabled:opacity-50';
export const BTN =
  'inline-flex items-center justify-center gap-1.5 px-3 py-1.5 text-sm font-medium rounded-lg border border-gray-300 dark:border-gray-700 text-gray-700 dark:text-gray-200 bg-white dark:bg-gray-900 hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors disabled:opacity-50';

// Status pills (EI/CI badge style) — colour always sits beside its label (§4.7).
export const PILL = {
  emerald: 'inline-flex items-center gap-1 text-[11px] font-semibold uppercase tracking-wide px-2 py-0.5 rounded-full bg-emerald-50 dark:bg-emerald-500/10 text-emerald-700 dark:text-emerald-400 border border-emerald-200 dark:border-emerald-500/20',
  amber: 'inline-flex items-center gap-1 text-[11px] font-semibold uppercase tracking-wide px-2 py-0.5 rounded-full bg-amber-50 dark:bg-amber-500/10 text-amber-700 dark:text-amber-400 border border-amber-200 dark:border-amber-500/20',
  red: 'inline-flex items-center gap-1 text-[11px] font-semibold uppercase tracking-wide px-2 py-0.5 rounded-full bg-red-50 dark:bg-red-500/10 text-red-700 dark:text-red-400 border border-red-200 dark:border-red-500/20',
  gray: 'inline-flex items-center gap-1 text-[11px] font-semibold uppercase tracking-wide px-2 py-0.5 rounded-full bg-gray-100 dark:bg-gray-800 text-gray-600 dark:text-gray-400 border border-gray-200 dark:border-gray-700',
};

// Row hover used by list cards across the dashboard.
export const ROW_BUTTON =
  'w-full text-left px-4 sm:px-5 py-3 hover:bg-gray-50 dark:hover:bg-gray-800/50 transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-[#32B1FF]/50';
